module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/customize_desktop-3eda17373175003808c9886cc8449f3e.png";